__turbopack_context__.v({
  "show_poster__badge": "ShowPoster-module-scss-module__nhmUXq__show_poster__badge",
  "show_poster__compass_rose": "ShowPoster-module-scss-module__nhmUXq__show_poster__compass_rose",
  "show_poster__fallback": "ShowPoster-module-scss-module__nhmUXq__show_poster__fallback",
  "show_poster__link": "ShowPoster-module-scss-module__nhmUXq__show_poster__link",
  "splide__list": "ShowPoster-module-scss-module__nhmUXq__splide__list",
});
